import { Star, TrendingDown, TrendingUp } from "lucide-react";
import type { PublishedFeedback } from "../../lib/performance-lens/types.ts";
import styles from "./published-rating-summary.module.css";

type RatingKind = "team" | "self";

export default function PublishedRatingSummary({ results, kind, variant, loading = false, unavailable = false }: {
  results: PublishedFeedback[];
  kind: RatingKind;
  variant: "metric" | "card";
  loading?: boolean;
  unavailable?: boolean;
}) {
  const field = kind === "team" ? "teamAverage" : "selfAverage";
  const rating = results[0]?.result[field] ?? null;
  const previous = results[1]?.result[field] ?? null;
  const change = rating !== null && previous !== null ? rating - previous : null;
  const label = kind === "team" ? "Your rating" : "Self rating";
  const caption = loading ? "Loading rating" : unavailable ? "Rating unavailable" : rating === null ? "No published rating yet" : "Latest published rating";

  return <div className={variant === "card" ? styles.card : styles.metric} role="group" aria-label={label}>
    <span className={styles.icon}><Star size={variant === "card" ? 22 : 18} fill="currentColor" aria-hidden="true" /></span>
    <div className={styles.copy}>
      {variant === "card" && <span className={styles.label}>{label}</span>}
      <strong className={styles.value}>{loading ? "…" : rating === null ? "—" : rating.toFixed(2)}{!loading && rating !== null && <small> / 5</small>}</strong>
      <span className={styles.caption}>{variant === "metric" ? label : caption}</span>
      {variant === "metric" && !loading && (unavailable || rating === null) && <small className={styles.emptyHint}>{unavailable ? "Unavailable" : "Not published yet"}</small>}
      {variant === "card" && change !== null && <span className={change >= 0 ? styles.trendUp : styles.trendDown}>
        {change >= 0 ? <TrendingUp size={15} aria-hidden="true" /> : <TrendingDown size={15} aria-hidden="true" />}
        {change > 0 ? "+" : ""}{change.toFixed(2)} vs previous view
      </span>}
    </div>
  </div>;
}
